import { useState } from 'react';
import { Container, Typography, Card, CardContent, TextField, Button, Alert, Box } from '@mui/material';

const MerchantPage = () => {
  const [form, setForm] = useState({
    business_name: '', business_type: '', contact_name: '', contact_email: '', contact_phone: '',
    address: '', city: '', state: '', postal_code: '', proposed_offer: ''
  });
  const [status, setStatus] = useState<'idle'|'loading'|'success'|'error'>('idle');
  const [error, setError] = useState<string | null>(null);
  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setError(null);
    try {
      const res = await fetch(`${API_URL}/api/perks/merchants/interest`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Submission failed');
      setStatus('success');
    } catch (e: any) {
      setError(e.message || 'Submission failed');
      setStatus('error');
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Partner with mdcv.me</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Offer a discount to verified medical professionals and drive traffic from our network.
      </Typography>

      <Card>
        <CardContent>
          <form onSubmit={onSubmit}>
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
              <TextField name="business_name" label="Business Name" required value={form.business_name} onChange={onChange} />
              <TextField name="business_type" label="Business Type" value={form.business_type} onChange={onChange} />
              <TextField name="contact_name" label="Contact Name" value={form.contact_name} onChange={onChange} />
              <TextField name="contact_email" label="Contact Email" type="email" required value={form.contact_email} onChange={onChange} />
              <TextField name="contact_phone" label="Contact Phone" value={form.contact_phone} onChange={onChange} />
              <Box sx={{ gridColumn: '1 / -1' }}>
                <TextField name="address" label="Address" fullWidth value={form.address} onChange={onChange} />
              </Box>
              <TextField name="city" label="City" value={form.city} onChange={onChange} />
              <TextField name="state" label="State" value={form.state} onChange={onChange} />
              <TextField name="postal_code" label="Postal Code" value={form.postal_code} onChange={onChange} />
              <Box sx={{ gridColumn: '1 / -1' }}>
                <TextField name="proposed_offer" label="Proposed Offer" fullWidth multiline minRows={3} value={form.proposed_offer} onChange={onChange} />
              </Box>
              <Box sx={{ gridColumn: '1 / -1' }}>
                <Button type="submit" variant="contained" disabled={status==='loading'}>
                  {status==='loading' ? 'Submitting…' : 'Submit Interest'}
                </Button>
              </Box>
            </Box>
          </form>

          {status==='success' && (
            <Alert severity="success" sx={{ mt: 2 }}>
              Thank you! We’ll reach out with next steps.
            </Alert>
          )}
          {status==='error' && error && (
            <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default MerchantPage;
